module.exports = __webpack_public_path__ + "assets/review-management.290ed898.svg";